var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "filterForm",
              attrs: {
                model: _vm.filterForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_h_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: {
                            change: function ($event) {
                              return _vm.themeChange("horizontal")
                            },
                          },
                          model: {
                            value: _vm.filterForm.horizontal,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterForm, "horizontal", $$v)
                            },
                            expression: "filterForm.horizontal",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_left"))),
                          ]),
                          _c(
                            "el-radio-button",
                            {
                              attrs: {
                                disabled: _vm.filterForm.vertical === "center",
                                label: "center",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("chart.text_pos_center")) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c("el-radio-button", { attrs: { label: "right" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_right"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_v_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: {
                            change: function ($event) {
                              return _vm.themeChange("vertical")
                            },
                          },
                          model: {
                            value: _vm.filterForm.vertical,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterForm, "vertical", $$v)
                            },
                            expression: "filterForm.vertical",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "top" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_top"))),
                          ]),
                          _c(
                            "el-radio-button",
                            {
                              attrs: {
                                disabled:
                                  _vm.filterForm.horizontal === "center",
                                label: "center",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("chart.text_pos_center")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("panel.title_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.themeChange("color")
                          },
                        },
                        model: {
                          value: _vm.filterForm.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.filterForm, "color", $$v)
                          },
                          expression: "filterForm.color",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-divider", [
                    _vm._v(_vm._s(_vm.$t("panel.input_style"))),
                  ]),
                  _c(
                    "el-row",
                    { staticStyle: { height: "40px", overflow: "hidden" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            "padding-left": "10px",
                            "padding-top": "8px",
                          },
                          attrs: { span: 4 },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("panel.board")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-top": "5px" },
                          attrs: { span: 4 },
                        },
                        [
                          _c("el-color-picker", {
                            staticClass: "color-picker-style",
                            attrs: {
                              size: "mini",
                              predefine: _vm.predefineColors,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.themeChange("brColor")
                              },
                            },
                            model: {
                              value: _vm.filterForm.brColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "brColor", $$v)
                              },
                              expression: "filterForm.brColor",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            "padding-left": "10px",
                            "padding-top": "8px",
                          },
                          attrs: { span: 4 },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("panel.text")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-top": "5px" },
                          attrs: { span: 4 },
                        },
                        [
                          _c("el-color-picker", {
                            staticClass: "color-picker-style",
                            attrs: {
                              size: "mini",
                              predefine: _vm.predefineColors,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.themeChange("wordColor")
                              },
                            },
                            model: {
                              value: _vm.filterForm.wordColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "wordColor", $$v)
                              },
                              expression: "filterForm.wordColor",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            "padding-left": "10px",
                            "padding-top": "8px",
                          },
                          attrs: { span: 4 },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("panel.board_background")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-top": "5px" },
                          attrs: { span: 4 },
                        },
                        [
                          _c("el-color-picker", {
                            staticClass: "color-picker-style",
                            attrs: {
                              size: "mini",
                              predefine: _vm.predefineColors,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.themeChange("innerBgColor")
                              },
                            },
                            model: {
                              value: _vm.filterForm.innerBgColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "innerBgColor", $$v)
                              },
                              expression: "filterForm.innerBgColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }